import type { ReactElement } from "react";

import Video from "../../primitives/video/video";
import VideoGrid from "./blocks/media/video-grid/video-grid";
import VideoWithParagraph from "./blocks/media/video-with-paragraph/video-with-paragraph";
import VideoWithTitle from "./blocks/media/video-with-title/video-with-title";
import ImageAndTextWithButtonTwoColumns from "./blocks/sections/image-and-text-with-button-two-columns/image-and-text-with-button-two-columns";

export default function getTemplate(): ReactElement[] {
  return [
    <VideoWithTitle key="video-with-title" videoAreaSize="Small" />,
    <VideoWithParagraph key="video-with-paragraph-1" showCTA>
      <Video url="https://youtu.be/T46akS7ght4" />
    </VideoWithParagraph>,
    <ImageAndTextWithButtonTwoColumns
      key="image-and-text-with-button-two-columns"
      showCTA
    />,
    <VideoGrid
      key="video-grid"
      videoList={[
        {
          kind: "embed",
          url: "https://youtu.be/pUA2oyQCq-U",
          id: "1",
          thumbnail: "https://i.ytimg.com/vi/pUA2oyQCq-U/maxresdefault.jpg",
          title: "RingCentral Events | Keynote & demo",
        },
        {
          kind: "embed",
          url: "https://youtu.be/b0ISqJyDV8Q",
          id: "2",
          thumbnail: "https://i.ytimg.com/vi/b0ISqJyDV8Q/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
        {
          kind: "embed",
          url: "https://youtu.be/6qRRtPgN9HI",
          id: "3",
          thumbnail: "https://i.ytimg.com/vi/6qRRtPgN9HI/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
        {
          kind: "embed",
          url: "https://youtu.be/LGp2xyCVoog",
          id: "4",
          thumbnail: "https://i.ytimg.com/vi/LGp2xyCVoog/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
        {
          kind: "embed",
          url: "https://youtu.be/jm-5fWfV_o0",
          id: "5",
          thumbnail: "https://i.ytimg.com/vi/jm-5fWfV_o0/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
        {
          kind: "embed",
          url: "https://youtu.be/ZBRVdAsOpCU",
          id: "6",
          thumbnail: "https://i.ytimg.com/vi/ZBRVdAsOpCU/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
        {
          kind: "embed",
          url: "https://youtu.be/hgIkL5sCu08",
          id: "7",
          thumbnail: "https://i.ytimg.com/vi/hgIkL5sCu08/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
        {
          kind: "embed",
          url: "https://youtu.be/l_Munn0fr8M",
          id: "8",
          thumbnail: "https://i.ytimg.com/vi/l_Munn0fr8M/maxresdefault.jpg",
          title:
            "RingCentral Events | Create High-Productions Event Experiences with Studio",
        },
      ]}
    />,
  ];
}
